import React from 'react';
import './politicaPrivacidade.css';
import Logo from '../../assets/brasao_sejus.png';

// Página pública (fora de PrivateRoute/RestrictedRoute — ver src/routes/index.js) com a
// política de privacidade do app móvel SIGEPEN, exigida pela Google Play Store (Data Safety /
// campo "Política de privacidade" no Console). Conteúdo espelha 1:1 o rascunho técnico em
// PRIVACY_POLICY.md do repositório siapen_mobile — qualquer alteração de conteúdo deve ser
// replicada nos dois lugares, ou o outro arquivo removido depois que este for revisado
// juridicamente e publicado.

function PoliticaPrivacidade() {
  return (
    <div className="privacy-page">
      <div className="privacy-container">
        <img src={Logo} alt="SEJUS-PI" className="privacy-logo" />
        <h1>Política de Privacidade — SIGEPEN</h1>


        <p className="privacy-updated">
          <strong>Última atualização:</strong> <span className="privacy-pending">17/09/2026</span>
        </p>

        <h2>1. Quem somos</h2>
        <p>
          O SIGEPEN é um aplicativo de uso interno da Secretaria de Justiça do Estado do Piauí
          (SEJUS-PI), destinado a servidores e a órgãos parceiros autorizados (Poder Judiciário,
          Defensoria Pública, Ministério Público, Polícia Militar/Civil) para consulta e registro
          de dados do Sistema Penitenciário do Piauí (SIAPEN). Não é um aplicativo de uso
          público — o acesso exige login com credenciais fornecidas pela SEJUS-PI.
        </p>
        <p>
          <strong>Canal de contato do encarregado (DPO) / ouvidoria:</strong>{' '}
          <a href="mailto:cpd@sejus.pi.gov.br">cpd@sejus.pi.gov.br</a>
        </p>

        <h2>2. Dados tratados pelo aplicativo</h2>

        <h3>2.1 Dados da pessoa que usa o aplicativo (servidor/usuário autorizado)</h3>
        <ul>
          <li>E-mail e senha de acesso, usados exclusivamente para autenticação no servidor da SEJUS-PI.</li>
          <li>
            Grupo/perfil de acesso (ex.: unidade, cargo) e unidade(s) de vínculo, usados para
            controlar o que cada usuário pode ver dentro do próprio sistema.
          </li>
        </ul>

        <h3>2.2 Dados de terceiros (pessoas custodiadas pelo sistema penitenciário)</h3>
        <p>
          O aplicativo é uma ferramenta de consulta e registro de prontuário do sistema
          prisional. Ele exibe e, na tela de Cadastro/Entrada, também coleta os seguintes dados
          de terceiros (pessoas custodiadas, não usuários do app):
        </p>
        <ul>
          <li>
            Identificação: nome, nome da mãe, CPF, data de nascimento, nacionalidade,
            naturalidade, RG, gênero, cor/etnia, estado civil.
          </li>
          <li>Fotografia (foto de perfil, capturada pela câmera ou selecionada da galeria do aparelho).</li>
          <li>
            Dados do prontuário prisional: status, unidade/pavilhão/cela, regime, natureza da
            prisão, histórico de movimentações/transferências/saídas, dados de saúde e ficha de
            inclusão (quando aplicável ao fluxo de cadastro), entre outros dados administrativos
            do sistema penitenciário.
          </li>
          <li>
            Assinatura digital (traço desenhado na tela) capturada no fluxo de Cadastro/Entrada,
            incluída como imagem dentro do PDF da Ficha de Inclusão gerado pelo próprio
            aplicativo.
          </li>
        </ul>
        <p>
          Esses dados <strong>não são coletados para finalidade própria do aplicativo</strong> —
          eles já existem no sistema da SEJUS-PI (SIAPEN) e o aplicativo apenas os exibe
          (consulta) ou os envia ao mesmo sistema (cadastro), como uma interface móvel do sistema
          já existente.
        </p>

        <h3>2.3 Biometria do aparelho (Face ID / impressão digital)</h3>
        <p>
          O aplicativo pode usar a biometria já cadastrada no aparelho do usuário (Face ID,
          leitor de impressão digital) <strong>apenas como trava de acesso local</strong>, pedindo
          essa confirmação ao reabrir o aplicativo depois de um tempo em segundo plano.{' '}
          <strong>
            O aplicativo nunca recebe, processa, armazena ou transmite nenhum dado biométrico
          </strong>{' '}
          — a verificação é feita inteiramente pelo sistema operacional do aparelho (iOS/Android),
          e o aplicativo só recebe uma confirmação de "autenticado" ou "não autenticado", nunca a
          impressão digital ou o rosto da pessoa.
        </p>

        <h3>2.4 Dados de localização</h3>
        <p>O aplicativo <strong>não coleta dados de localização/GPS</strong>.</p>

        <h2>3. Como os dados são armazenados e protegidos</h2>
        <ul>
          <li>
            <strong>Sessão de login</strong> (token de acesso, dados do usuário logado):
            armazenados de forma criptografada no próprio aparelho, usando o armazenamento
            seguro nativo do sistema (Keychain no iOS, Keystore no Android) — nunca em texto
            simples.
          </li>
          <li>
            <strong>Cache local pra uso sem internet</strong>: o aplicativo guarda uma cópia da
            última consulta feita com sucesso (ex.: última lista de internos vista, últimos dados
            de um prontuário) no armazenamento do próprio aparelho, para exibir quando a conexão
            de internet cair. Esse cache é <strong>apagado automaticamente ao sair da conta</strong>{' '}
            (logout), justamente para não ficar disponível para outro usuário que venha a usar o
            mesmo aparelho depois.
          </li>
          <li>
            <strong>Proteção contra captura de tela</strong>: nas telas com dado sensível
            (detalhes de um prontuário, cadastro), o aplicativo bloqueia print e gravação de tela
            do próprio sistema operacional.
          </li>
          <li>Toda comunicação entre o aplicativo e o servidor da SEJUS-PI é feita por HTTPS (criptografada em trânsito).</li>
          <li>O aplicativo <strong>não usa nenhum SDK de propaganda, analytics ou rastreamento de terceiros</strong>.</li>
        </ul>

        <h2>4. Compartilhamento de dados</h2>
        <p>
          Os dados tratados pelo aplicativo <strong>não são compartilhados com terceiros</strong>.
          Todo o tráfego é exclusivamente entre o aplicativo (no aparelho do usuário autorizado) e
          o servidor da própria SEJUS-PI — não há integração com nenhum serviço externo de
          terceiros (analytics, propaganda, redes sociais, etc.).
        </p>

        <h2>5. Direitos do titular dos dados (LGPD)</h2>
        <p>
          Nos termos da Lei Geral de Proteção de Dados (Lei nº 13.709/2018), o titular dos dados
          pode solicitar, junto ao controlador indicado no item 1: confirmação da existência de
          tratamento, acesso aos dados, correção de dados incompletos/inexatos, e demais direitos
          previstos na LGPD. Solicitações devem ser feitas pelo canal indicado no item 1.
        </p>

        <h2>6. Retenção e exclusão de dados</h2>
        <p>
          Dados do prontuário prisional são retidos conforme as regras e prazos legais aplicáveis
          ao sistema penitenciário (fora do controle do próprio aplicativo, que é só uma interface
          de acesso). O cache local de uso offline no aparelho é apagado automaticamente a cada
          logout.
        </p>

        <h2>7. Alterações nesta política</h2>
        <p>
          Esta política pode ser atualizada. A versão vigente está sempre disponível nesta mesma
          página.
        </p>
      </div>
    </div>
  );
}

export default PoliticaPrivacidade;
